"use strict";
window.NodeList &&
  !NodeList.prototype.forEach &&
  (NodeList.prototype.forEach = Array.prototype.forEach);
var WpbfPremium = {};
(WpbfPremium.site = (function (t) {
  var e = !(!window.wp || !wp.customize),
    a = { desktop: 1024, tablet: 768, mobile: 480 };
  function n() {
    o("desktop"),
      o("tablet"),
      o("mobile"),
      t(document).on(
        "click",
        ".wpbf-video-opt-in-button, .wpbf-video-opt-in-image",
        function (e) {
          e.preventDefault();
          var e = t(this).parent().next(),
            n = e.attr("data-wpbf-video");
          e.attr("data-wpbf-video"),
            e.children().attr("src", n),
            e.removeClass("opt-in"),
            this.parentNode.remove(this);
        },
      ),
      window.addEventListener("load", function (e) {
        var n = t(".wpbf-post-grid-masonry");
        n.length &&
          n.isotope({
            itemSelector: ".wpbf-article-wrapper",
            transitionDuration: 0,
          });
      });
  }
  function o(e) {
    var n = "wpbf-" + e + "-breakpoint-[\\w-]*\\b",
      n = t("body").attr("class").match(n);
    null != n &&
      ((a[e] = n.toString().match(/\d+/)),
      (a[e] = Array.isArray(a[e]) ? a[e][0] : a[e]));
  }
  return n(), n(), { isInsideCustomizer: e, breakpoints: a };
})(jQuery)),
  (WpbfPremium.desktopMenu = (function (a) {
    var e = WpbfPremium.isInsideCustomizer,
      n = WpbfPremium.site.breakpoints,
      t = parseInt(
        a(".wpbf-navigation").data("sub-menu-animation-duration"),
        10,
      ),
      o =
        (a(document).on("click", ".wpbf-menu-full-screen a", function () {
          i("full-screen") &&
            (this.href.match("#") || this.href.match("/#")) &&
            u("full-screen");
        }),
        a(document).on("click", ".wpbf-menu-off-canvas a", function () {
          var e;
          i("off-canvas") &&
            (this.href.match("#") || this.href.match("/#")) &&
            (!this.parentNode.classList.contains("menu-item-has-children") ||
            a(this).closest(".wpbf-mega-menu").length
              ? u("off-canvas")
              : (e = a((e = this)).siblings(".wpbf-submenu-toggle")).length &&
                ((e = e[0]).classList.contains("active") ? f : l)(e));
        }),
        a(document).on("click", ".wpbf-menu-toggle", function () {
          i("full-screen")
            ? s("full-screen")
            : i("off-canvas") && s("off-canvas");
        }),
        a(document).on(
          "click",
          ".wpbf-menu-full-screen .wpbf-close",
          function () {
            u("full-screen");
          },
        ),
        // a(document).on("click", ".wpbf-menu-full-screen", function () {
        //   u("full-screen");
        // }),
        a(document).on(
          "click",
          ".wpbf-menu-full-screen.active nav",
          function (e) {
            e.stopPropagation();
          },
        ),
        a(document).on(
          "click",
          ".wpbf-menu-off-canvas .wpbf-close",
          function () {
            s("off-canvas");
          },
        ),
        window.addEventListener("click", function () {
          i("off-canvas") && u("off-canvas");
        }),
        a(document).on("keyup", function (e) {
          ("Escape" !== e.key && "Esc" !== e.key && 27 !== e.keyCode) ||
            (i("full-screen")
              ? u("full-screen")
              : i("off-canvas") && u("off-canvas"));
        }),
        a(window).on("resize", function () {
          var e = a(window).width();
          i("off-canvas") && e < n.desktop && u("off-canvas");
        }),
        a(document).on(
          "click",
          '.wpbf-mega-menu > .sub-menu > .menu-item a[href="#"]',
          function (e) {
            e.preventDefault();
          },
        ),
        a(window).on("resize", function () {
          var e;
          a(window).width() > n.desktop
            ? (e = a(".wpbf-mobile-mega-menu")).length &&
              (e
                .removeClass("wpbf-mobile-mega-menu")
                .addClass("wpbf-mega-menu"),
              e.hasClass("wpbf-mobile-mega-menu-container-width") &&
                e
                  .removeClass("wpbf-mobile-mega-menu-container-width")
                  .addClass("wpbf-mega-menu-container-width"),
              e.hasClass("wpbf-mobile-mega-menu-full-width") &&
                e
                  .removeClass("wpbf-mobile-mega-menu-full-width")
                  .addClass("wpbf-mega-menu-full-width"),
              e.hasClass("wpbf-mobile-mega-menu-custom-width") &&
                e
                  .removeClass("wpbf-mobile-mega-menu-custom-width")
                  .addClass("wpbf-mega-menu-custom-width"))
            : (e = a(".wpbf-mega-menu")).length &&
              (e
                .removeClass("wpbf-mega-menu")
                .addClass("wpbf-mobile-mega-menu"),
              e.hasClass("wpbf-mega-menu-container-width") &&
                e
                  .removeClass("wpbf-mega-menu-container-width")
                  .addClass("wpbf-mobile-mega-menu-container-width"),
              e.hasClass("wpbf-mega-menu-full-width") &&
                e
                  .removeClass("wpbf-mega-menu-full-width")
                  .addClass("wpbf-mobile-mega-menu-full-width"),
              e.hasClass("wpbf-mega-menu-custom-width") &&
                e
                  .removeClass("wpbf-mega-menu-custom-width")
                  .addClass("wpbf-mobile-mega-menu-custom-width"));
        }),
        a(document).on(
          "click",
          ".wpbf-menu-off-canvas .wpbf-submenu-toggle",
          function (e) {
            e.preventDefault(),
              (this.classList.contains("active") ? f : l)(this);
          },
        ),
        ".wpbf-sub-menu-animation-down > .menu-item-has-children"),
      o =
        (a(document)
          .on("mouseenter", o, function () {
            a(".sub-menu", this)
              .first()
              .css({ display: "block" })
              .stop()
              .animate({ marginTop: "0", opacity: "1" }, t);
          })
          .on("mouseleave", o, function () {
            a(".sub-menu", this)
              .first()
              .stop()
              .animate({ opacity: "0", marginTop: "-10px" }, t, function () {
                this.style.display = "none";
              });
          }),
        ".wpbf-sub-menu-animation-up > .menu-item-has-children"),
      o =
        (a(document)
          .on("mouseenter", o, function () {
            a(".sub-menu", this)
              .first()
              .css({ display: "block" })
              .stop()
              .animate({ marginTop: "0", opacity: "1" }, t);
          })
          .on("mouseleave", o, function () {
            a(".sub-menu", this)
              .first()
              .stop()
              .animate({ opacity: "0", marginTop: "10px" }, t, function () {
                this.style.display = "none";
              });
          }),
        ".wpbf-sub-menu-animation-zoom-in > .menu-item-has-children"),
      o =
        (a(document)
          .on("mouseenter", o, function () {
            a(".sub-menu", this)
              .first()
              .stop(!0)
              .css({ display: "block" })
              .transition({ scale: "1", opacity: "1" }, t);
          })
          .on("mouseleave", o, function () {
            a(".sub-menu", this)
              .first()
              .stop(!0)
              .transition({ scale: ".95", opacity: "0" }, t)
              .fadeOut(5);
          }),
        ".wpbf-sub-menu-animation-zoom-out > .menu-item-has-children");
    function i(e) {
      switch (e) {
        case "full-screen":
          return !!document.querySelector(".wpbf-menu-full-screen");
        case "off-canvas":
          return !!document.querySelector(".wpbf-menu-off-canvas");
        default:
          return;
      }
    }
    function s(e) {
      var n;
      "full-screen" === e
        ? ((n = document.querySelector(
            ".wpbf-menu-full-screen",
          )).classList.contains("active")
            ? u
            : c)(e, n)
        : "off-canvas" === e &&
          ((n = document.querySelector(
            ".wpbf-menu-off-canvas",
          )).classList.contains("active")
            ? u
            : c)(e, n);
    }
    function c(e, n) {
      var t = document.querySelector(".wpbf-menu-toggle");
      t.classList.add("active"),
        t.setAttribute("aria-expanded", "true"),
        n.classList.add("active"),
        "full-screen" === e
          ? a(n).stop().fadeIn(150)
          : "off-canvas" === e &&
            (n.setAttribute("tabindex", "-1"),
            n.focus(),
            document.body.classList.add("active"),
            a(".wpbf-menu-overlay")
              .stop()
              .css({ display: "block" })
              .animate({ opacity: "1" }, 300));
    }
    function u(e, n) {
      n ||
        ("full-screen" === e
          ? (n = document.querySelector(".wpbf-menu-full-screen"))
          : "off-canvas" === e &&
            (n = document.querySelector(".wpbf-menu-off-canvas")));
      var t = document.querySelector(".wpbf-menu-toggle");
      t.classList.remove("active"),
        t.setAttribute("aria-expanded", "false"),
        n.classList.remove("active"),
        "full-screen" === e
          ? a(n).stop().fadeOut(150)
          : "off-canvas" === e &&
            (document.body.classList.remove("active"),
            a(".wpbf-menu-overlay")
              .stop()
              .animate({ opacity: "0" }, 300, function () {
                this.style.display = "none";
              }));
    }
    function l(e) {
      a("i", e).removeClass("wpbff-arrow-down").addClass("wpbff-arrow-up"),
        a(e)
          .addClass("active")
          .attr("aria-expanded", "true")
          .siblings(".sub-menu")
          .stop()
          .slideDown();
    }
    function f(e) {
      a("i", e).removeClass("wpbff-arrow-up").addClass("wpbff-arrow-down"),
        a(e)
          .removeClass("active")
          .attr("aria-expanded", "false")
          .siblings(".sub-menu")
          .stop()
          .slideUp();
    }
    a(document)
      .on("mouseenter", o, function () {
        a(".sub-menu", this)
          .first()
          .stop(!0)
          .css({ display: "block" })
          .transition({ scale: "1", opacity: "1" }, t);
      })
      .on("mouseleave", o, function () {
        a(".sub-menu", this)
          .first()
          .stop(!0)
          .transition({ scale: "1.05", opacity: "0" }, t)
          .fadeOut(5);
      }),
      a(document).on(
        {
          mouseenter: function () {
            a(this).find(".wpbf-woo-sub-menu").stop().fadeIn(t);
          },
          mouseleave: function () {
            a(this).find(".wpbf-woo-sub-menu").stop().fadeOut(t);
          },
        },
        ".wpbf-woo-menu-item.menu-item-has-children",
      ),
      a(window).on("resize", function () {
        var e = a(window).width();
        document.querySelector('[data-transparent-header-disabled="mobile"]') &&
          (e <= n.desktop
            ? (a("body").removeClass("wpbf-transparent-header"),
              a(".wpbf-navigation").removeClass("wpbf-navigation-transparent"))
            : (a("body").addClass("wpbf-transparent-header"),
              a(".wpbf-navigation").addClass("wpbf-navigation-transparent")));
      }),
      a(document).on(
        "click",
        ".wpbf-menu-off-canvas, .wpbf-menu-toggle",
        function (e) {
          e.stopPropagation();
        },
      ),
      e &&
        wp.customize.bind("preview-ready", function () {
          wp.customize.selectiveRefresh.bind(
            "partial-content-rendered",
            function (e) {
              t = parseInt(
                a(".wpbf-navigation").data("sub-menu-animation-duration"),
                10,
              );
            },
          );
        });
  })(jQuery)),
  (WpbfPremium.mobileMenu = (function (t) {
    var n = WpbfPremium.site.breakpoints;
    function a(e) {
      return (
        "mobile-off-canvas" === e &&
        !!document.querySelector(".wpbf-mobile-menu-off-canvas")
      );
    }
    function e(e) {
      var n = document.querySelector(".wpbf-mobile-menu-toggle");
      n &&
        (n.classList.contains("active")
          ? o(e)
          : ((n = e),
            (e = document.querySelector(".wpbf-mobile-menu-toggle")) &&
              (e.classList.add("active"),
              e.setAttribute("aria-expanded", "true"),
              "mobile-off-canvas" === n &&
                (document.body.classList.add("active-mobile"),
                t(".wpbf-mobile-menu-container").addClass("active"),
                t(".wpbf-mobile-menu-overlay")
                  .css({ display: "block" })
                  .stop()
                  .animate({ opacity: "1" }, 300)))));
    }
    function o(e) {
      var n = document.querySelector(".wpbf-mobile-menu-toggle");
      n &&
        "mobile-off-canvas" === e &&
        n.classList.contains("active") &&
        (document.body.classList.remove("active-mobile"),
        n.classList.remove("active"),
        n.setAttribute("aria-expanded", "false"),
        t(".wpbf-mobile-menu-container").removeClass("active"),
        t(".wpbf-mobile-menu-overlay")
          .stop()
          .animate({ opacity: "0" }, 300, function () {
            this.style.display = "none";
          }));
    }
    function i(e) {
      t("i", e).removeClass("wpbff-arrow-down").addClass("wpbff-arrow-up"),
        e.classList.add("active"),
        e.setAttribute("aria-expanded", "true"),
        t(e).siblings(".sub-menu").stop().slideDown(),
        t(e)
          .closest(".wpbf-navigation")
          .hasClass("wpbf-mobile-sub-menu-auto-collapse") &&
          t(e)
            .closest(".menu-item-has-children")
            .siblings(".menu-item-has-children")
            .each(function (e, n) {
              s(n.querySelector(".wpbf-submenu-toggle"));
            });
    }
    function s(e) {
      t("i", e).removeClass("wpbff-arrow-up").addClass("wpbff-arrow-down"),
        e.classList.remove("active"),
        e.setAttribute("aria-expanded", "false"),
        t(e).siblings(".sub-menu").stop().slideUp();
    }
    t(document).on("click", ".wpbf-mobile-menu a", function () {
      var e;
      a("mobile-off-canvas") &&
        (this.href.match("#") || this.href.match("/#")) &&
        (!this.parentNode.classList.contains("menu-item-has-children") ||
        t(this).closest(".wpbf-mobile-mega-menu").length
          ? o("mobile-off-canvas")
          : (e = t((e = this)).siblings(".wpbf-submenu-toggle")).length &&
            ((e = e[0]).classList.contains("active") ? s : i)(e));
    }),
      t(document).on("click", ".wpbf-mobile-menu-toggle", function () {
        a("mobile-off-canvas") && e("mobile-off-canvas");
      }),
      t(document).on(
        "click",
        ".wpbf-mobile-menu-off-canvas .wpbf-close",
        function () {
          e("mobile-off-canvas");
        },
      ),
      window.addEventListener("click", function () {
        a("mobile-off-canvas") && o("mobile-off-canvas");
      }),
      t(document).on("keyup", function (e) {
        ("Escape" !== e.key && "Esc" !== e.key && 27 !== e.keyCode) ||
          (a("mobile-off-canvas") && o("mobile-off-canvas"));
      }),
      t(window).on("resize", function () {
        var e = t(window).width();
        a("mobile-off-canvas") && e > n.desktop && o("mobile-off-canvas");
      }),
      t(document).on(
        "click",
        ".wpbf-mobile-menu-off-canvas .wpbf-submenu-toggle",
        function (e) {
          e.preventDefault(),
            ((e = this).classList.contains("active") ? s : i)(e);
        },
      ),
      t(document).on(
        "click",
        ".wpbf-mobile-menu-container, .wpbf-mobile-menu-toggle",
        function (e) {
          e.stopPropagation();
        },
      );
  })(jQuery)),
  (WpbfPremium.stickyNavigation = (function (t) {
    var a = WpbfPremium.site.isInsideCustomizer,
      o = {},
      i = {},
      s = {};
    function n() {
      (o.nav = document.querySelector(".wpbf-navigation")),
        o.nav &&
          ((o.$nav = t(o.nav)),
          (o.sticky = o.nav.dataset.sticky),
          (o.delay = o.nav.dataset.stickyDelay),
          (o.animation = o.nav.dataset.stickyAnimation),
          (o.duration = o.nav.dataset.stickyAnimationDuration),
          (o.duration = parseInt(o.duration, 10)),
          (o.distance = parseInt(o.$nav.offset().top) + parseInt(o.delay, 10)),
          (i.prevScrollTop = window.pageYOffset),
          (i.isFired = 0),
          (s.menuActiveLogoUrl = t(".wpbf-logo").data("menu-active-logo")),
          (s.menuLogoUrl = t(".wpbf-logo img").attr("src")),
          (s.mobileMenuLogoUrl = t(".wpbf-mobile-logo img").attr("src")));
    }
    function c() {
      o.sticky ? t(window).on("scroll", e) : t(window).off("scroll", e);
    }
    function e() {
      var e, n;
      (!a || (o.nav && o.sticky)) &&
        ((n = t(window).scrollTop()),
        (e = o.$nav.outerHeight()),
        n > o.distance && !i.isFired
          ? (o.nav.classList.add("wpbf-navigation-active"),
            "slide" === o.animation
              ? o.$nav
                  .css({ position: "fixed", left: "0", zIndex: "666", top: -e })
                  .stop()
                  .animate({ top: 0 }, o.duration)
              : "fade" === o.animation
              ? o.$nav
                  .css({
                    display: "none",
                    position: "fixed",
                    top: "0",
                    left: "0",
                    zIndex: "666",
                  })
                  .stop()
                  .fadeIn(o.duration)
              : "shrink" === o.animation
              ? (o.$nav.css({
                  position: "fixed",
                  top: "0",
                  left: "0",
                  zIndex: "666",
                }),
                "shrink" === o.animation &&
                  o.nav.classList.add("wpbf-navigation-shrink"))
              : (o.$nav.css({
                  position: "fixed",
                  top: "0",
                  left: "0",
                  zIndex: "666",
                }),
                "scroll" === o.animation &&
                  o.nav.classList.add("wpbf-navigation-animate")),
            document.body.classList.contains("wpbf-transparent-header") ||
              t(".wpbf-page-header").css("marginTop", e),
            s.menuActiveLogoUrl &&
              (t(".wpbf-logo img").attr("src", s.menuActiveLogoUrl),
              t(".wpbf-mobile-logo img").attr("src", s.menuActiveLogoUrl)),
            (i.isFired = 1))
          : n < o.distance &&
            i.isFired &&
            (o.nav.classList.remove("wpbf-navigation-active"),
            o.nav.classList.remove("wpbf-navigation-animate"),
            o.nav.classList.remove("wpbf-navigation-shrink"),
            t("body").hasClass("wpbf-transparent-header")
              ? o.$nav.css({
                  position: "absolute",
                  top: "",
                  left: "",
                  zIndex: "",
                })
              : (o.$nav.css({ position: "", top: "", left: "", zIndex: "" }),
                t(".wpbf-page-header").css("marginTop", "")),
            s.menuActiveLogoUrl &&
              (t(".wpbf-logo img").attr("src", s.menuLogoUrl),
              t(".wpbf-mobile-logo img").attr("src", s.mobileMenuLogoUrl)),
            (i.isFired = 0)),
        "scroll" === o.animation &&
          ((e = t(window).scrollTop()),
          (n = o.$nav.outerHeight()),
          e > i.prevScrollTop && n < e
            ? (t(".wpbf-navigation").css({ top: -n }),
              t(".wpbf-navigation")
                .removeClass("wpbf-navigation-scroll-up")
                .addClass("wpbf-navigation-scroll-down"))
            : e + t(window).height() < t(document).height() &&
              (t(".wpbf-navigation").css({ top: "0px" }),
              t(".wpbf-navigation")
                .removeClass("wpbf-navigation-scroll-down")
                .addClass("wpbf-navigation-scroll-up")),
          (i.prevScrollTop = e)));
    }
    return (
      a &&
        wp.customize.selectiveRefresh.bind(
          "partial-content-rendered",
          function (e) {
            n(), c();
          },
        ),
      n(),
      c(),
      { opts: o, state: i, data: s }
    );
  })(jQuery));
